import React from 'react';

import { styled } from '@uhg-abyss/web/tools/styled';
import ChatMessageList from './components/ChatMessageList';
import { ChatProvider } from '../../optumus-core/src/context/ChatConfigContext';
import type { ProviderCardDetailsProps } from './components/ProviderCardDetails';
import type { IChatSchedulingResponse } from '../../optumus-core/src/types/ChatSchedulingResponse.types';

export interface ChatWidgetProps {
    initialPrompt?: string;
    botIcon?: string;
    selectedProvider?: ProviderCardDetailsProps;
    onProviderResults?: (response: IChatSchedulingResponse) => void;
}

const ChatWidget: React.FC<ChatWidgetProps> = ({
    initialPrompt,
    selectedProvider,
    onProviderResults,
}) => (
    <ChatProvider>
        <WidgetShell>
            <ChatMessageList
                initialPrompt={initialPrompt}
                selectedProvider={selectedProvider}
                onProviderResults={onProviderResults}
            />
        </WidgetShell>
    </ChatProvider>
);

const WidgetShell = styled('section', {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    backgroundColor: '$core.color.neutral.0',
});

export default ChatWidget;